module.exports = __webpack_public_path__ + "fonts/NeuePlakBlack_normal_normal.50a725e.woff2";